<template>
  <div>
    <template v-if="!contracts.length">
      <div class="text-center border-dashed border-grey-200 border-2 px-4 py-12 bg-white">
        <h2>No contracts available</h2>
        <p class="mb-8">
          You currently don't have any contracts for this competition.
        </p>
        <button
          class="text-primary-800 uppercase text-sm font-bold hover:opacity-75 transition-all transition-normal"
          @click="addContract"
        >
          <icon
            icon="add-circle"
            class="icons-primary w-16 h-16 mx-auto block mb-3"
          />
          Create Contract
        </button>
      </div>
    </template>
    <template v-else>
      <ul class="mt-4 list-reset flex flex-wrap -mx-4">
        <li
          v-for="(contract) in contracts"
          :key="contract.id"
          class="w-full lg:w-1/3 lg:flex p-4"
        >
          <button @click="editContract(contract)">
            {{ contract.title }}
          </button>
          <button @click="deleteContract(contract)">
            <icon icon="close-circle" class="w-4 h-4 icons-negative" />
          </button>
        </li>
      </ul>
    </template>
    <contract-builder 
      v-if="showContractBuilder"
      :contract="selectedContract" 
      @close="closeContractBuilder"
      @save:contract="saveContract"
    />
  </div>
</template>

<script>
export default {
  name: 'CompetitionEditTemplates',
  data() {
    return {
      showContractBuilder: false,
      selectedContract: null,
      contracts: []
    }
  },
  methods: {
    addContract() {
      axios.post(route('competitions.add-contract', {
        competition: this.state.competition.uuid
      }), {
        title: 'New Contract',
        sections: []
      })
      .then( ({data}) => {
        this.contracts.push(data)
        this.selectedContract = data
        this.showContractBuilder = true
      })
      .catch( error => {
        console.log(error)
      })
    },
    editContract(contract) {
      this.selectedContract = contract
      this.showContractBuilder = true
    },
    deleteContract(deletedContract) {
      if(!confirm('Are you sure you would like to delete this template?')) return
      axios.delete(route('competitions.update-contract', {
        competition: this.state.competition.uuid,
        template: deletedContract.id
      }))
      .then( ({ data }) => {
        const contractIndex = this.contracts.findIndex((contract) => contract.id === data.id)
        this.contracts.splice(contractIndex, 1);
      })
      .catch( error => {
        console.log('Nope.')
      })
    },
    saveContract(updatedContract) {
      axios.patch(route('competitions.update-contract', {
        competition: this.state.competition.uuid,
        template: updatedContract.id
      }), updatedContract)
      .then( ({ data }) => {
        const contractIndex = this.contracts.findIndex((contract) => contract.id === data.id)
        if(contractIndex === -1) {
          this.contracts.push(data)
        } else {
          this.contracts[contractIndex] = data;
        }
      })
      .catch( error => {
        console.log('Nope.')
      })
      .then( () => this.closeContractBuilder() )
    },
    closeContractBuilder() {
      this.showContractBuilder = false
      this.selectedContract = null
    }
  },
  created() {
    this.contracts = [...this.state.templates]
  }
}
</script>
